/**
 * FileDeleteFailedErr 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileDeleteFailedErr
 */
export interface FileDeleteFailedErr {
  /** 文件ID */
  file_id?: any
  /** 错误信息 */
  error?: string
}

/**
 * FileDeleteFailedErr Schema
 */
export const FileDeleteFailedErrSchema: SchemaDefinition = {
  properties: {
    file_id: {
      description: '文件ID',
      format: 'string',
      type: 'file',
      label: '文件ID',
    },
    error: {
      description: '错误信息',
      format: 'string',
      type: 'string',
      label: '错误信息',
    },
  },
  type: 'object',
}
